import * as links from 'documents-lib/js/lib/links';
import getRecipientName from 'documents-ui/utils/getRecipientName';
import { Button } from 'foundations-components/transitional/components/Button';
import { Flex } from 'foundations-components/components/Flex';
import { Link } from 'foundations-components/transitional/components/Link';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import ContactAvatar from 'documents-ui/components/ContactAvatar';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SummaryRecipientContactCell = ({
  contact,
  onViewDetails
}) => {
  const renderContact = () => {
    const name = contact ? getRecipientName(contact) : '';
    const nameNode = contact && name ? /*#__PURE__*/_jsx(Link, {
      target: "_blank",
      external: true,
      href: links.getContactProfileURL(Number(contact.get('vid'))),
      children: name
    }) : /*#__PURE__*/_jsx(FormattedMessage, {
      message: "summary.recipientsTable.row.someone"
    });
    return /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      gap: "300",
      children: [/*#__PURE__*/_jsx(ContactAvatar, {
        contact: contact
      }), nameNode]
    });
  };
  const handleClick = useCallback(e => {
    e.stopPropagation();
    onViewDetails(e);
  }, [onViewDetails]);
  return /*#__PURE__*/_jsx(TableHoverCell, {
    hoverContent: /*#__PURE__*/_jsx("span", {
      children: /*#__PURE__*/_jsx(Button, {
        size: "extra-small",
        use: "tertiary-light",
        onClick: handleClick,
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "summary.recipientsTable.row.viewDetails"
        })
      })
    }),
    children: renderContact()
  });
};
export default SummaryRecipientContactCell;